/* Eyebrow — microscopic pill badge */
import React from "react";

interface EyebrowProps {
  className?: string;
  children: React.ReactNode;
}

export const Eyebrow = ({ className, children }: EyebrowProps) => {
  return (
    <span
      className={`inline-flex items-center rounded-full border border-[var(--color-accent)]/10 bg-[var(--color-accent)]/5 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-[var(--color-accent)] ${className || ""}`}
    >
      {children}
    </span>
  );
};
